import { useEffect, useRef } from "react";
import { useLocation } from "wouter";
import { ANALYTICS_ENABLED_EVENT, trackContactPageView } from "@/lib/analytics";

function normalizePath(location: string) {
  return location.split(/[?#]/, 1)[0] || "/";
}

export default function AnalyticsRouteTracker() {
  const [location] = useLocation();
  const contactVisitTracked = useRef(false);

  useEffect(() => {
    const pathname = normalizePath(location);

    if (pathname !== "/contactos") {
      contactVisitTracked.current = false;
      return;
    }

    const trackCurrentRoute = () => {
      if (contactVisitTracked.current) return;
      if (trackContactPageView(pathname)) {
        contactVisitTracked.current = true;
      }
    };

    trackCurrentRoute();
    window.addEventListener(ANALYTICS_ENABLED_EVENT, trackCurrentRoute);

    return () => {
      window.removeEventListener(ANALYTICS_ENABLED_EVENT, trackCurrentRoute);
    };
  }, [location]);

  return null;
}
